import Platform from '@/types/Platform'

export default Platform.fromStorable({
	id: 'vinterior',
	settings: {
		logo: require('@/assets/logo-vinterior.png'),
		name: 'Vinterior',
		format: {
			width: 2500,
			height: 2500
		},
		maxCount: 20,
		setRules: {
			'0': [
				{
					category: ['special', 'title'],
					allowFullPicture: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					}
				}
			]
		},
		rules: {
			'0': [
				{
					category: ['special', 'title'],
					allowFullPicture: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					}
				}
			],
			'1': [
				{
					category: ['special', 'measurements'],
					allowFullPicture: true,
					padding: {
						top: 0.24,
						bottom: 0.31
					},
					overlays: [{ name: 'MeasurementAnnotation', args: [false] }]
				}
			],
			'2': [
				{
					category: ['functions', null],
					allowFullPicture: true,
					allowFindNext: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					}
				}
			],
			'3': [
				{
					category: ['functions', null],
					allowFullPicture: true,
					allowFindNext: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			'4': [
				{
					category: ['functions', null],
					allowFullPicture: true,
					allowFindNext: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			'5': [
				{
					category: ['functions', null],
					allowFullPicture: true,
					allowFindNext: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			'6': [
				{
					category: ['special', 'materialDetail'],
					allowFullPicture: true
				}
			],
			'7': [
				{
					category: ['detail', null],
					allowFullPicture: true,
					allowFindNext: true
				}
			],
			'8': [
				{
					category: ['detail', null],
					allowFullPicture: true,
					allowFindNext: true
				}
			],
			'9': [
				{
					category: ['detail', null],
					allowFullPicture: true,
					allowFindNext: true
				}
			],
			'10': [
				{
					category: ['detail', 'damages'],
					allowFullPicture: true,
					allowFindNext: true
				}
			],
			'11': [
				{
					category: ['detail', 'damages'],
					allowFullPicture: true,
					allowFindNext: true
				}
			],
			'12': [
				{
					category: ['detail', 'damages'],
					allowFullPicture: true,
					allowFindNext: true
				}
			],
			'13': [
				{
					category: ['special', 'colors'],
					allowFullPicture: true
				}
			],
			'14': [
				{
					category: ['detail', null],
					allowFullPicture: true
				}
			],
			'15': [
				{
					category: ['special', 'logo'],
					allowFullPicture: true
				}
			]
		},
		fillRule: [
			{
				category: ['alternate', null],
				allowFullPicture: true,
				padding: {
					top: 0.2,
					bottom: 0.2
				}
			}
		]
	}
})
